export default __webpack_public_path__ + "static/media/subtraction.5f49e520.svg";